import { render } from "./AddPrepaidAccountPage.vue?vue&type=template&id=70556120&ts=true"
import script from "./AddPrepaidAccountPage.vue?vue&type=script&lang=ts"
export * from "./AddPrepaidAccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__